import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useState } from 'react';
import { Slide } from 'react-reveal'
// import './Careers.css'
import '../../App.css'



function Career() {
    const [change, setChange] = useState('Create')

    setInterval(() => {
        setChange('Evolve')
    }, 3000);



    return (
        <>
            <Container className='container text-center mt-5'>
                <div className="row career-heading">
                    <div className="text-center">
                        <Slide up>

                            <h2>
                                <Slide up>

                                    <span className={change}> {change} </span>
                                </Slide>

                                Every One</h2>
                            <h3 className="mb-5">Find Your Job At Lacauna Venture</h3>
                        </Slide>

                    </div>
                </div>
                <div className="container w-75 m-auto">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 career-box">
                            <h6> For Startup Founders</h6>
                            <h3>Find A Mentor and Get Your Brain Stormed</h3>
                            <p>Become an advocate for small businesses in your area and get their ideas on how to grow bigger more quickly by listening, developing the skill sets that will help them reach out and be understood during a period of growth. Work with fellow entrepreneurs who have experience working alongside others as well through mentorships or mentorship programs</p>
                        </div>
                        <div className="col-sm-12 col-md-12 career-box">
                            <h6>
                                For Career Networks
                            </h6>
                            <h3>Build a Career with Lacuna Venture</h3>
                            <p>Build a Career with Lacuna Venture. If you're serious about starting your own tech startup, this is the perfect program to start from scratch as an entrepreneur! Courses are taught by local entrepreneurs and engineers who share their experience of working in businesses across Asia through stories that have real-life business value embedded into them.</p>
                        </div>
                    </div>
                </div>


            </Container>
        </>
    )
}

export default Career
const Container = styled.div` 

.Evolve{
    color:black ;
}

        h1{
            color:var(--primary-color) ;
        }
        input{
            box-sizing:border-box;
            width:100% ;
            padding:10px ;
        }
        label{
            font-size:18px ;
        }
        img{
            width:100% ;
        }
        .career-box{
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;
            padding: 50px;
            box-shadow:0px 2px 50px 0px rgba(163, 161, 170, 0.884);
            border-radius:20px;
            color:white;
            text-align:justify;
            margin-top:30px;
        }
        .career-box h3{
            color:black;
            font-weight:800;
            font-size:35px;
        
        }
        .career-box h6{
            font-size:24px;
            color: black;
            margin:0px;
            padding-bottom:10px;
        }
        p{
            color:black;
            text-align:justify;
        }
        .career-heading h2{
        font-size:80px;
        margin-top:50px ;
        margin-bottom:40px ;
}

        @media (max-width:710px){
            .career-heading h2{
                font-size:50px ;
                line-height: 80px;
            }
        }
`